import { __assign, __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var cameraIcon = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 17 17", fill: "currentColor", width: size || "17", height: size || "17" }, props),
        React.createElement("path", { d: "M10.625 3.542l1.432 2.125h2.818v8.5H2.125v-8.5H4.96l1.415-2.125h4.25zm-.377.708H6.754L5.34 6.375H2.833v7.083h11.334V6.375H11.68L10.248 4.25zM8.5 6.375c1.565 0 2.833 1.269 2.833 2.833 0 1.565-1.268 2.834-2.833 2.834-1.565 0-2.833-1.269-2.833-2.834 0-1.564 1.268-2.833 2.833-2.833zm0 .708c-1.174 0-2.125.952-2.125 2.125 0 1.174.951 2.125 2.125 2.125s2.125-.951 2.125-2.125c0-1.173-.951-2.125-2.125-2.125z", fillRule: "evenodd" })));
};
cameraIcon.displayName = 'cameraIcon';
export default cameraIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=cameraIcon.js.map